/* eslint-disable
    @trello/enforce-file-ownership,
    @typescript-eslint/no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
let BoardInviteRestrictValues, InviteRestrictValues;
module.exports.InviteRestrictValues = InviteRestrictValues = {
  ANY: 'any',
  MANAGED: 'managed',
  MANAGED_OR_DOMAIN: 'managed-or-domain',
  DOMAIN: 'domain',
};

module.exports.BoardInviteRestrictValues = BoardInviteRestrictValues = {
  ANY: 'any',
  ORG: 'org',
  MANAGED: 'managed',
  ORG_OR_MANAGED: 'org-or-managed',
  LICENSED: 'licensed',
  LICENSED_OR_MANAGED: 'licensed-or-managed',
};
